import {Divider} from 'semantic-ui-react';
import styled from 'styled-components';

export const DangerZoneDivider = styled(Divider)`
  margintop: 20px;
`;
